import React, { useEffect } from 'react'
import { useHistory } from 'react-router-dom'

import { Box } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import Tab from '@material-ui/core/Tab'
import TabContext from '@material-ui/lab/TabContext'
import TabList from '@material-ui/lab/TabList'

import { yellowPalette } from '@masfront/common-b2c/src/modules/ui/theme/colors'
import { CustomTheme } from '@masfront/common-b2c/src/modules/ui/theme/utils'
import useQuery from '@masfront/common-csr/router/hooks/useQuery'

export interface TabConfig {
  label: string
  value: string
  disabled: boolean
}

interface B2CTabContextListProps {
  tabConfigs: TabConfig[]
  queryParam?: string
  children: React.ReactNode
  initialValue?: string
  className?: string
  classes?: { [key: string]: string }
  subTab?: boolean
}

const useStyles = makeStyles((theme: CustomTheme) => {
  return {
    bigIndicator: {
      backgroundColor: yellowPalette[200],
      height: 8,
    },
    subTab: {
      '&.MuiTab-root:first-child': {
        marginLeft: theme.spacing(6),
      },
      '&.MuiTab-root': {
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),
      },
      '&.Mui-selected': {
        borderRadius: '0px',
        backgroundColor: 'transparent',
      },
    },
  }
})

const B2CTabContextList: React.FC<B2CTabContextListProps> = ({
  tabConfigs,
  queryParam = '',
  initialValue,
  children,
  className,
  classes,
  subTab = false,
}) => {
  const useStylesclasses = useStyles()
  const history = useHistory()
  const query = useQuery()
  const queryParamVal = queryParam && query.get(queryParam)
  const initialValueState = initialValue || tabConfigs?.[0]?.value || ''

  const [value, setValue] = React.useState(initialValueState)

  const handleChange = (_event: React.ChangeEvent<unknown>, newValue: string) => {
    if (queryParam) {
      query.set(queryParam, newValue)
      history.push({
        search: query.toString(),
      })
    } else {
      setValue(newValue)
    }
  }

  useEffect(() => {
    if (queryParam) {
      if (queryParamVal) {
        setValue(queryParamVal)
      } else {
        setValue(initialValueState)
      }
    } else {
      setValue(initialValueState)
    }
  }, [queryParamVal])

  return (
    <Box className={className} data-hook="b2c-tab-context-list">
      <TabContext value={value}>
        <TabList
          classes={
            subTab
              ? { root: classes?.tabsRoot, indicator: useStylesclasses.bigIndicator }
              : { root: classes?.tabsRoot }
          }
          onChange={handleChange}
        >
          {tabConfigs.map((tabConfig) => (
            <Tab
              key={tabConfig.value}
              label={tabConfig.label}
              value={tabConfig.value}
              disabled={tabConfig.disabled}
              className={subTab ? useStylesclasses.subTab : ''}
            />
          ))}
        </TabList>
        {children}
      </TabContext>
    </Box>
  )
}

export default B2CTabContextList
